import { Grid } from '@mui/material';
import React from 'react';
import LetterAvatar from '../../LetterAvatar/LetterAvatar';

interface ISingleUserProps {
  profilePic: string;
  firstName: string;
  lastName: string | null;
  hideStatus?: boolean;
}

function SingleUser({ profilePic, firstName, lastName, hideStatus }: ISingleUserProps) {
  return (
    <Grid position="relative">
      {profilePic ? (
        <img
          src={`${process.env.REACT_APP_MEDIA_FILES_BASE_URL}/${profilePic}`}
          alt="user"
          width={28}
          height={28}
          style={{ borderRadius: '50%', objectFit: 'cover' }}
        />
      ) : (
        <LetterAvatar firstName={firstName} lastName={lastName} size={28} />
      )}
      {!hideStatus && (
        <img
          src="/assets/icons/online.svg"
          alt="online"
          style={{ position: 'absolute', top: '-3px', right: '-3px' }}
        />
      )}
    </Grid>
  );
}

export default SingleUser;
